export default "__VITE_ASSET__D_rPeG0L__"